export const ArrowUp = 38;
export const ArrowDown = 40;
export const Enter = 13;
export const Tab = 9;



// WEBPACK FOOTER //
// ./../src/utilities/KeyCodes.js